import React from 'react';
export function WarningCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a1 1 0 01-1-1l.008-5a1 1 0 011-1 1 1 0 011 1L13 13a1 1 0 01-1 1zM11.994 17a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22h-.015A10 10 0 0112 2h.015A10 10 0 0112 22zm0-18a8 8 0 10-.012 16H12a8.01 8.01 0 008-7.988A8.001 8.001 0 0012.012 4H12z"
  }));
}